class SiteNavigationDesktop
    extends SiteNavigation
{
    private readonly _site: Site;

    constructor(site: Site) {
        super();

        this._site = site;
        let button = new SiteButton({
            icon: "apps",
            title: site.Config.strings["overview"]
        });
        button.addClass("rounded");
        button.on("click", async () => await site.overview(false));
        this.append(button);
    }
    
    
    isActive() {
        return this.containsClass("active");
    }

    makeActive() {
        if(this.isActive())
            return this;
        
        let button = new SiteButton({
            icon: "arrow_back",
            title: this._site.Config.strings["previous card"]
        });
        button.addClass("rounded")
            .addClass("rounded-small");
        button.on("click", () => {
            var activeCard = this._site.query("#containers > .container.active").first<SiteContainer>();
            if (activeCard != null)
            {
                var prevCard = activeCard.prev<SiteContainer>();
                
                if (prevCard == null)
                    prevCard = this._site.query("#containers > .container:not(.active)").last<SiteContainer>();

                if (prevCard != null)
                    this._site.makeContainerActive(prevCard, false);
            }
        });
        this.append(button);

        if(this._site.isSplit()) {
            let button = new SiteButton({
                icon: "cached",
                title: this._site.Config.strings["flip split"]
            });
            button.addClass("rounded")
            .addClass("rounded-small");
            button.on("click", () => this._site.toggleSplit());
            this.append(button);
        } else {
            let button = new SiteButton({
                icon: "compare",
                title: this._site.Config.strings["split screen"]
            });
            button.addClass("rounded")
            .addClass("rounded-small");
            button.on("click", async () => await this._site.overview(true));
            this.append(button);
        }
        this.addClass("active");
        return this;
    }
    makeInactive() {
        this.removeClass("active");
        this.query("button:not(:first-child)").all(a => a.remove());
        return this;
    }
}
